export type Operation = {
  op: 'replace' | 'remove' | 'add';
  path: string;
  value?: unknown;
};

export enum OperationType {
  REPLACE = 'replace',
  REMOVE = 'remove',
  ADD = 'add',
}

export function generateJsonPatchOperations(
  initialValue: Record<string, any>,
  updatedValue: Record<string, any>,
  prefix = ''
): Operation[] {
  const keys = new Set([...Object.keys(initialValue), ...Object.keys(updatedValue)]);

  return Array.from(keys).reduce((acc: Operation[], key: string) => {
    if (!initialValue[key]) {
      if (updatedValue[key]) {
        acc.push(generateOperation(OperationType.ADD, generatePath(prefix, key), updatedValue[key]));
      }
    } else if (!updatedValue[key]) {
      acc.push(generateOperation(OperationType.REMOVE, generatePath(prefix, key), null));
    } else if (initialValue[key] !== updatedValue[key]) {
      if (initialValue[key] instanceof Object && updatedValue[key] instanceof Object) {
        acc = [...acc, ...generateJsonPatchOperations(initialValue[key], updatedValue[key], key)];
      } else {
        acc.push(generateOperation(OperationType.REPLACE, generatePath(prefix, key), updatedValue[key]));
      }
    }
    return acc;
  }, [] as Operation[]);
}

export function generateOperation(operation: OperationType, path: string, newValue: unknown): Operation {
  return {
    op: operation,
    path: path,
    ...(operation !== 'remove' && { value: newValue }),
  };
}

function generatePath(prefix: string, jsonPath: string): string {
  const jsonPathReplace = jsonPath.replace('.', '/');

  if (prefix.length) {
    return `/${prefix}/${jsonPathReplace}`;
  }

  return `/${jsonPathReplace}`;
}
